import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { notification } from 'antd'
import { ICreateBadgePayload } from '@app-store/slices/badges/create'

interface TaskAction extends Action {
    payload: ICreateBadgePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.badges.create

function* createBadgeSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/event/settings/badge`, payload.data)
        if (response.success) {
            notification.success({
                message: 'Badge created successfully.'
            })
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* createBadgeSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createBadgeSagaTask)
}

export default createBadgeSaga
